import { render, staticRenderFns } from "./ContractsLayout.vue?vue&type=template&id=0a6e36e9&scoped=true&"
import script from "./ContractsLayout.vue?vue&type=script&lang=js&"
export * from "./ContractsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6e36e9",
  null
  
)

export default component.exports